<template>
  <div>
    <h2 class="step-name">Drycow Strategy</h2>

    <div class="step-section">

      <discussion-points title="Drycow Strategy"
        comments-field="drycow_strategy_discussion"
        points="What was discussed, moving to selective drycow therapy, herd testing">
      </discussion-points>

      <div>
        <h3> Dry Cow Sales </h3>
        <p> Product quantities purchased by season.</p>
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Animal ID</th>
              <th>Farm Name</th>
              <th>Product</th>
              <th>{{getChartData('dc_last_season')}}</th>
              <th>{{getChartData('dc_this_season')}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(sale, index) in getChartData('dc_get_drycow_sales')" :key="index">

              <td class="text-left">{{ sale["Animal ID"] }}</td>
              <td class="text-left">{{ sale["Farm name"] }}</td>
              <td class="text-left">{{ sale["Product"] }}</td>
              <td class="text-left">{{ sale["qty_ls"] }}</td>
              <td class="text-left">{{ sale["qty_ts"] }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="step-section">
      <div class="clearfix" :style="{ width: widthForRow(getFieldValue('FARMS')) + 'px' }">
        <div v-for="farm in getFieldValue('FARMS')" class="farm-fields" :key="farm.id">
          <h3>{{ farm.farm_label }}</h3>

          <fieldset>

            <radio-input label="Herd - vet tech admin"
                         :field-name="`farm_${farm.id}-pl_tech_vet_admin`"
                         :addEmailNotification="true"
                         :choices="[
                                    {value: 'Yes', display: 'Yes'},
                                    {value: 'No', display: 'No'},
                                    ]"
                         :disabled="isReadOnly">
            </radio-input>

            <radio-input label="Heifer - vet tech admin"
                         :field-name="`farm_${farm.id}-pl_heifer_its`"
                         :addEmailNotification="true"
                         :choices="[
                                    {value: 'Yes', display: 'Yes'},
                                    {value: 'No', display: 'No'},
                                    ]"
                         :disabled="isReadOnly">
            </radio-input>
          </fieldset>

          <div class="step-section">
            <div class="form-group">
              <text-area label="If Yes is selected for herd - Notes to Techs (Pref date/time, # of people, cows per session)"
                         :field-name="`farm_${farm.id}-herd_notes_to_techs`"
                         :disabled="isReadOnly">
              </text-area>

              <div class="form-group" v-if="getFieldValue(`farm_${farm.id}-last_year_herd_notes_to_techs`)">
                <label>Last year</label>
                <textarea rows="5"
                          cols="50"
                          :value="getFieldValue(`farm_${farm.id}-last_year_herd_notes_to_techs`)"
                          class="form-control"
                          disabled>
                </textarea>
              </div>
            </div>
          </div>

          <div class="step-section">
            <div class="form-group">

              <text-area label="If Yes is selected for heifer - Notes to Techs (Pref date/time, location, contact)"
                         :field-name="`farm_${farm.id}-heifers_notes_to_techs`"
                         :disabled="isReadOnly">
              </text-area>

              <div class="form-group" v-if="getFieldValue(`farm_${farm.id}-last_year_heifers_notes_to_techs`)">
                <label>Last year</label>
                <textarea rows="5"
                          cols="50"
                          :value="getFieldValue(`farm_${farm.id}-last_year_heifers_notes_to_techs`)"
                          class="form-control"
                          disabled>
                </textarea>
              </div>
            </div>
          </div>

          <div class="comments">
            <span class="form-group">
              <label for="dry_period_mastitis_comments">Dry period mastitis comments</label>
              <comments :field-name="`farm_${farm.id}-dry_period_mastitis_comments`" :isReadOnly="isReadOnly">
              </comments>
            </span>
          </div>

          <div class="comments">
            <span class="form-group">
              <label for="spring_mastitis_comments">Spring mastitis comments</label>
              <comments :field-name="`farm_${farm.id}-spring_mastitis_comments`" :isReadOnly="isReadOnly">
              </comments>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component_v2'


export default {
  name: 'DryCowStrategy',
  mixins: [ baseComponent ],
  methods: {
    validatePlanned: function(farmId){
      var total = this.getFieldValue(`farm_${farmId}-pl_la_dcat`) +
        this.getFieldValue(`farm_${farmId}-pl_sa_dcat`) +
        this.getFieldValue(`farm_${farmId}-pl_nothing`) +
        this.getFieldValue(`farm_${farmId}-pl_herd_its_only`) +
        this.getFieldValue(`farm_${farmId}-pl_la_its`) +
        this.getFieldValue(`farm_${farmId}-pl_sa_its`);

      if (total != 100) {
        this.errors.add({
          field: `farm_${farmId}-pl_mmq_error`,
          msg: 'Sum of planned percentages need to add to 100.'
        })
      } else {
        this.errors.remove(`farm_${farmId}-pl_mmq_error`)
      }
    },
    toggleNotifications: function() {
      let fieldsToCheck = this.getFieldValue('FARMS', this.$options.name)
        .map(farm => [`farm_${farm.id}-pl_tech_vet_admin`, `farm_${farm.id}-pl_heifer_its`])
        .flat()

      this.setEmailNotification({
        slug: 'notes-to-techs-mastitis-preventive-measures',
        value: fieldsToCheck.some(fieldName => this.getFieldValue(fieldName, this.$options.name) == 'Yes')
      })
    }
  },
};
</script>
<style>
.badge-nobg {
  background-color: transparent;
  color: black;
}
</style>
